import React from 'react';

import { TextFileIcon } from '@lp/ds-next';
import { Flex, Typography } from 'antd';

export const LocalCard = ({
  isError,
  title,
  subTitle,
}: {
  isError: boolean;
  title: string;
  subTitle: string;
}) => (
  <Flex
    style={{
      padding: '.75rem',
      alignItems: 'center',
      gap: '0.5rem',
      backgroundColor: isError ? '#FFF1F4' : '#E9F5F1',
      boxShadow: isError ? '0 2px 1px 0 #EDC5C5' : '0 2px 1px 0 #C6E2D7',
      borderRadius: '10px',
      minWidth: '220px',
    }}
  >
    <div
      style={{
        padding: '0.75rem',
        backgroundColor: isError ? '#FFB4AF' : '#C3EFDE',
        borderRadius: '4px',
      }}
    >
      <TextFileIcon />
    </div>
    <Flex vertical content="center">
      <Typography.Title level={5} style={{ marginBottom: '0' }}>
        {title}
      </Typography.Title>
      <Typography.Text style={{ color: '#A5A2A2' }}>{subTitle}</Typography.Text>
    </Flex>
  </Flex>
);
